import RestService from '../services/rest';

async function createPunchOutN2Rule({
  code,
  name,
  description,
  type,
}) {
  return RestService.postAuthenticated('panel/punchoutN2Rules/create', {
    code,
    name,
    description,
    type,
  });
}

async function updatePunchOutN2Rule({
  ruleId,
  name,
  description,
  type,
}) {
  return RestService.putAuthenticated('panel/punchoutN2Rules/update', {
    ruleId,
    name,
    description,
    type,
  });
}

async function getPunchOutN2Rules(limit, skip, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/punchoutN2Rules/getAllRules?limit=${limit}&skip=${skip}&order=${order}&field=${field}`,
  );
}

export default {
  createPunchOutN2Rule,
  getPunchOutN2Rules,
  updatePunchOutN2Rule,
};
